module.exports = __webpack_public_path__ + "static/media/abode-wellness-faq.e39cd74d.jpg";